import { emailRegExp, validURLRegExp } from 'constants/regexpConstants';
import { IProjectLink } from 'modules/project-management/models/interfaces';
import { LINK_TYPES } from '../../project-links/constants';
import { getLinkByType } from '../helpers/utils';

const { GIT_OTHER, GIT_GITHUB, EMAIL, CASE_STUDY, SLIDE_DECK, DOCS_DECKS } =
  LINK_TYPES;

const requiredLinksTypes = [DOCS_DECKS];

// Link types that store a file path / upload URL — skip standard URL format validation for these
const uploadLinkTypes = [SLIDE_DECK, CASE_STUDY];

export const SHOWROOM_VALIDATION_ERRORS = Object.freeze({
  FIELD_IS_REQUIRED: 'This field is required.',
  ATTACH_YOUR_FILE: 'Please attach your file',
  INVALID_EPAM_GITLAB_LINK:
    'Showroom request contains invalid EPAM GitLab link.',
  NO_ACTIVITY_IN_THE_REPOSITORY:
    'No activity in the repository. Please add another source.',
  WRONG_EMAIL_FORMAT:
    'Email should correspond to the format i.e. sample@domain.com.',
  LINK_FORMAT_INVALID:
    'Link does not have a proper URL pattern i.e. http://example.com',
});

export const addToShowroomSchema = (info: any): any => {
  const githubLink = getLinkByType(info.projectLinks, GIT_GITHUB)?.link;
  const isEditorMode =
    (info.isEditor || info.isEventOrganizer) &&
    JSON.parse(info.editorSwitch ?? 'false');

  return {
    props: {
      industries: {
        isRequired: true,
        validators: [
          (value: any, parentValues: any) => {
            const industryType = parentValues.industryType;
            if (industryType === 'specific' && (!value || value.length === 0)) {
              return [SHOWROOM_VALIDATION_ERRORS.FIELD_IS_REQUIRED];
            }
            return [false];
          },
        ],
      },
      GIT_REPO: {
        isRequired: true,
        isDisabled: true,
        validators: [
          () => {
            if (!info.userHasActiveRepository && !githubLink) {
              return [SHOWROOM_VALIDATION_ERRORS.NO_ACTIVITY_IN_THE_REPOSITORY];
            }
            return [false];
          },
        ],
      },
      projectLinks: {
        all: {
          props: {
            link: {
              validators: [
                (value: string, parentValues: IProjectLink) => {
                  if (
                    !isEditorMode &&
                    !value &&
                    parentValues.linkType != null &&
                    requiredLinksTypes.includes(parentValues.linkType)
                  ) {
                    return [SHOWROOM_VALIDATION_ERRORS.FIELD_IS_REQUIRED];
                  }
                  if (
                    !isEditorMode &&
                    parentValues.linkType === SLIDE_DECK &&
                    !parentValues.file &&
                    !value
                  ) {
                    return [SHOWROOM_VALIDATION_ERRORS.ATTACH_YOUR_FILE];
                  }
                  if (
                    value &&
                    parentValues.linkType !== EMAIL &&
                    !uploadLinkTypes.includes(parentValues.linkType ?? '') &&
                    !validURLRegExp.test(value)
                  ) {
                    return [SHOWROOM_VALIDATION_ERRORS.LINK_FORMAT_INVALID];
                  }
                  if (
                    value &&
                    parentValues.linkType === EMAIL &&
                    !emailRegExp.test(value)
                  ) {
                    return [SHOWROOM_VALIDATION_ERRORS.WRONG_EMAIL_FORMAT];
                  }
                  if (parentValues?.linkType === GIT_OTHER) {
                    if (info.BE_ERROR_MESSAGE && !githubLink) {
                      return [
                        SHOWROOM_VALIDATION_ERRORS.INVALID_EPAM_GITLAB_LINK,
                      ];
                    }
                    if (!info.userHasActiveRepository && !githubLink) {
                      return [
                        SHOWROOM_VALIDATION_ERRORS.NO_ACTIVITY_IN_THE_REPOSITORY,
                      ];
                    }
                  }
                  return [false];
                },
              ],
            },
          },
        },
      },
    },
  };
};
